import {
  computePercentage,
  formatDate,
  getSymbol,
} from '../../../../helpers/functions';
import { Icon } from '../../../UI';
import { IStrategy, IStrategyAssetTarget } from '../../../../types/model';
import { ProfitLoss } from '../../../ProfitLoss';
import { CustomNumber } from '../../../CustomNumber/CustomNumber';

const PriceTargetsAccordionItem = ({
  currency,
  lastPrice,
  name,
  target,
  width,
  deleteTarget,
}: {
  currency: IStrategy['currency'];
  lastPrice: number;
  name: string;
  target: IStrategyAssetTarget;
  width: number;
  deleteTarget: (id: string | undefined) => void;
}) => {
  return (
    <>
      <div className="flex items-center pl-3 font-semibold text-sm h-12">
        {name}
      </div>

      {/* END DATE */}
      <div className="flex items-center text-sm">
        {formatDate(target.endDate)}
      </div>

      {/* STOP PROFIT */}
      <CustomNumber
        className="flex items-center text-sm"
        value={target.stopProfit}
        suffix={getSymbol(currency)}
      />

      {/* STOP PROFIT VARIATION */}
      <div className="flex items-center col-span-2 pl-5">
        <ProfitLoss
          isRow={width === 3}
          percentage={computePercentage(lastPrice, target.stopProfit, 100)}
          performancePosition="value"
          prefixPercentage="("
          suffixPercentage="%)"
          symbol={getSymbol(currency)}
          value={lastPrice - target.stopProfit}
        />
      </div>

      {/* STOP LOSS */}
      <CustomNumber
        className="flex items-center text-sm"
        value={target.stopLoss}
        suffix={getSymbol(currency)}
      />

      {/* STOP LOSS VARIATION */}
      <div className="flex col-span-2 items-center gap-1 pl-5">
        <ProfitLoss
          isRow={width === 3}
          percentage={computePercentage(lastPrice, target.stopLoss, 100)}
          performancePosition="value"
          prefixPercentage="("
          suffixPercentage="%)"
          symbol={getSymbol(currency)}
          value={lastPrice - target.stopLoss}
        />
        <Icon
          svgName="remove"
          className="ml-auto mr-2 cursor-pointer"
          onClick={() => deleteTarget(target.id)}
        />
      </div>
    </>
  );
};

export default PriceTargetsAccordionItem;
